import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import Buffering from "../components/Buffering"; 

import {listDataDictionaries, getEnumeration, listEnumerations} from "../utils/utilsDataDictionary";


class SelectEnumeration extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: null
        };

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.handleChange = this.handleChange.bind(this);
    

    }

    componentDidMount(){

        this.setup();
 
     }
 
     componentDidUpdate(prevProps, prevState){
 
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    
    }
 

    setup(){

        let StateChange = {
            renderState: null,
            selectDataDictionary: false,
            label: "Enumeration",
            idSelected: "",
            idDataDictionary: null,
            onChange: null
        }

        StateChange.name = getParam('name', this.props);

        if (getParam('label',this.props)){
            StateChange.label = getParam('label',this.props);
        }

        StateChange.selectDataDictionary = getParam('selectDataDictionary',this.props);
        StateChange.idDataDictionary = getParam('idDataDictionary', this.props);        
        StateChange.idSelected = getParam('value', this.props);
        StateChange.onChange = getParam('onChange', this.props);


        if (StateChange.selectDataDictionary){
            this.loadDataDictionaries();
        }
        
        if (StateChange.idDataDictionary){
            this.loadEnumerations(StateChange.idDataDictionary);
        }

        if (StateChange.idSelected){
            this.loadSelectedEnumeration(StateChange.idSelected);
        }

        this.setState(StateChange);

    }

    loadSelectedEnumeration(idEnumeration){

        if (!idEnumeration){
            return;
        }

        this.setState({renderState: "loading"});

        const onLoad = (Enumeration) => {
            const StateChange = {
                SelectedEnumeration: Enumeration,
                renderState: "loaded"
            };
            
            if (Enumeration.DataDictionary){
                StateChange.idDataDictionary = Enumeration.DataDictionary._id;
                this.loadEnumerations(StateChange.idDataDictionary);

            }
            
            this.setState(StateChange);
            
        };

        const onFail = (error) => {
            this.setState({
                renderState: "failed",
                errorMessage: error.message || "Failed to load enumeration"
            });
        };
        getEnumeration(this.dsd, idEnumeration, onLoad, onFail);

        return;
    }




    loadEnumerations(idDataDictionary){

        let StateChange = {};
        StateChange.Enumerations = null;

        if (idDataDictionary){

            const onLoad = function(data){
                let StateChange = {};
                StateChange.Enumerations = data;
                StateChange.renderState = "loaded";
                this.setState(StateChange);
                return;
            }.bind(this);

            const onFail = function(e){
                let StateChange = {};
                StateChange.renderState = "failed";

                StateChange.errorMessage = e.message;    
                if (e.response){
                    if (e.response.data){
                        if (e.response.data.message){
                            StateChange.errorMessage = e.response.data.message;
                        }
                    }
                }
                this.setState(StateChange);
                return;
            }.bind(this);

            StateChange.renderState = "loading";
            listEnumerations(this.dsd, {idDataDictionary:idDataDictionary},onLoad, onFail);
        }

        this.setState(StateChange);

        return;

    };


    loadDataDictionaries(){

        let StateChange = {};
        StateChange.DataDictionaries = null;

        const onLoad = function(data){
            let StateChange = {};
            StateChange.DataDictionaries = data;
            StateChange.renderState = "loaded";
            this.setState(StateChange);
            return;
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.renderState = "failed";

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);

        StateChange.renderState = "loading";
        listDataDictionaries(this.dsd, {},onLoad, onFail);

        this.setState(StateChange);

        return;
        
    };



    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            case "idDataDictionary":
                this.setState({"idDataDictionary":FormFieldValue})
                    if (FormFieldValue){
                        this.loadEnumerations(FormFieldValue);
                    }
                break;
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;
                this.setState({"FormData": FormData});
                break;
        };

    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
            case "loaded":

                const onChangeDictionary = function(event){

                    let StateChange = {};

                    let FormFieldValue = event.target.value;
                    
                    StateChange.idDataDictionary = FormFieldValue;
                    StateChange.Enumerations = null;
                    StateChange.idSelected = null;

                    if (StateChange.idDataDictionary){
                        this.loadEnumerations(StateChange.idDataDictionary);
                    }

                    this.setState(StateChange);

                }.bind(this);

                const onChangeEnumeration = function(event){

                    let FormFieldName = event.target.name;
                    let FormFieldValue = event.target.value;


                    if (FormFieldValue == ''){
                        FormFieldValue = null;
                    }

                    if (this.state.onChange){
                        this.state.onChange({target:{name:FormFieldName, value:FormFieldValue}});
                    }
                    return;                    

                }.bind(this);


                return(
                    <>                    

                        {this.state.selectDataDictionary && this.state.DataDictionaries &&
                            <PD.Select label='Select a Data Dictionary' name='idDataDictionary' onChange={onChangeDictionary} value={this.state.idDataDictionary}>
                                {
                                    this.state.DataDictionaries.map(
                                        (DataDictionary, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={DataDictionary._id}>{DataDictionary.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }


                        {this.state.Enumerations &&

                            <PD.Select label={this.state.label} name={this.state.name} onChange={onChangeEnumeration} value={this.state.idSelected}>
                                {
                                    this.state.Enumerations.map(
                                        (Enumeration, pos) => 
                                            {
                                                return(
                                                    <option key={pos} value={Enumeration._id}>{Enumeration.name}</option>
                                                )
                                            }
                                    )
                                }
                            </PD.Select>
                        }

                    </>
                )
        }

    }
}


export default function SelectEnumeration_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <SelectEnumeration {...props} navigation={navigation} location={location} params={params} />;
  }
